module.exports = "<div id=\"coachmarkBackground\" *ngIf=\"show\">\r\n</div>\r\n<img id=\"deviceImg\" [src]=\"getDeviceImg()\" *ngIf=\"show\">\r\n<div id=\"coachmarkDevice\"  *ngIf=\"show\">\r\n    <span id=\"deviceInfo\" [innerHTML]=\"'Hold and drag the card to change the <br> order of your devices' | translate\"></span>\r\n    <input class=\"fowardBtn\" type=\"submit\" [value]=\"('GOT IT!' | translate)\" (click)=\"gotIt()\" >\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/coachmarks/coachmark-device/coachmark-device.component.html
// module id = ./src/app/shared/components/coachmarks/coachmark-device/coachmark-device.component.html
// module chunks = main